// Données personnelles gardées sur l'appareil (pas de compte).
const FAVORITES_KEY = 'favoriteCantiques'
const RECENTS_KEY = 'recentCantiques'
const CATALOG_KEY = 'cantiquesCache'
export const MAX_RECENTS = 12

const readJson = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key)
    return raw ? JSON.parse(raw) : fallback
  } catch (_err) {
    return fallback
  }
}

const writeJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
    return true
  } catch (_err) {
    return false
  }
}

const readIdList = (key) => {
  const value = readJson(key, [])
  return Array.isArray(value) ? value.filter((id) => typeof id === 'string') : []
}

export const loadFavorites = () => readIdList(FAVORITES_KEY)
export const saveFavorites = (ids) => writeJson(FAVORITES_KEY, ids)

export const loadRecents = () => readIdList(RECENTS_KEY)
export const saveRecents = (ids) => writeJson(RECENTS_KEY, ids)

export const pushRecent = (ids, id) => [id, ...ids.filter((other) => other !== id)].slice(0, MAX_RECENTS)

// Last catalogue received from the API ({ cantiques, langues, savedAt }), used to show lyrics offline.
export const loadCatalogCache = () => {
  const value = readJson(CATALOG_KEY, null)
  return value && typeof value === 'object' ? value : {}
}

export const saveCatalogPart = (part, data) =>
  writeJson(CATALOG_KEY, { ...loadCatalogCache(), [part]: data, savedAt: Date.now() })
